import { render, staticRenderFns } from "./BtnEditarCliente.vue?vue&type=template&id=078bd899&"
import script from "./BtnEditarCliente.vue?vue&type=script&lang=js&"
export * from "./BtnEditarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports